import React from 'react'
import { useTranslation } from 'react-i18next'

import { Formik } from 'formik'
import moment from 'moment'
import * as Yup from 'yup'

import { now } from 'core/application/commons/dateUtils'

import { Button, DatePicker, DefaultSelect, Modal } from 'common/components'
import { parseZone } from 'common/dateFormatters'

type EndPerkModalProps = {
  showEndPerkModal: boolean
  endPerkRunOutDays: number
  endDatePerk: string
  loadingSubmit: boolean
  onPerkEndDateChange?: (endDate: string) => void
  onRunOutDaysChange?: (runOutDays: number) => void
  onCancel?: () => void
  onSubmit?: () => void
}

const EndPerkModal: React.FC<EndPerkModalProps> = ({
  showEndPerkModal,
  endPerkRunOutDays,
  endDatePerk,
  loadingSubmit,
  onPerkEndDateChange,
  onRunOutDaysChange,
  onCancel,
  onSubmit,
}) => {
  const { t: translate } = useTranslation()
  const endPerkOptions = [
    {
      id: 0,
      name: 'End immediately',
    },
    {
      id: 15,
      name: '15 days',
    },
    {
      id: 30,
      name: '30 days',
    },
  ]

  const onChangeRunOutDays = (selectedRunOutDays: any) => {
    onRunOutDaysChange(selectedRunOutDays)
  }
  return (
    <>
      <Modal
        onCancel={() => {
          onCancel()
          //setShowEndPerkModal(false)
        }}
        visible={showEndPerkModal}
        title={'End Perk'}
        footer={
          <div>
            <Button
              onClick={() => {
                onCancel()
                //  setShowEndPerkModal(false);
              }}
            >
              {translate('general.cancel')}
            </Button>
            <Button
              onClick={onSubmit}
              type="primary"
              disabled={endDatePerk === '' || endDatePerk === null}
              loading={loadingSubmit}
              className="ml-8"
            >
              {translate('general.submit')}
            </Button>
          </div>
        }
      >
        <Formik
          enableReinitialize={true}
          validationSchema={Yup.object({})}
          initialValues={endPerkOptions}
          onSubmit={(values) => {}}
        >
          <div>
            <div>
              <p>Change this perk</p>
              <p> {translate('admin-dashboard.benefit-details.table.modal.text-p1')}</p>
              <p> {translate('admin-dashboard.benefit-details.table.modal.text-p3')}</p>
            </div>

            <div className="mt-16">
              <span className="color-gray-9">
                {' '}
                {translate('admin-dashboard.benefit-details.table.modal.final-end-date')}
              </span>{' '}
              <br />
              <DatePicker
                name="endDate"
                onChange={(value) => onPerkEndDateChange(value)}
                className="width_50"
                disabledDate={(d) => {
                  if (now() > moment(endDatePerk)) {
                    return !d || d.isBefore(now(), 'day') || d.isAfter(moment(endDatePerk), 'day')
                  } else {
                    return !d || d.isBefore(now(), 'day')
                  }
                }}
                value={endDatePerk ? parseZone(endDatePerk) : null}
              ></DatePicker>
              <br />
              <span className="color-gray-9">
                {' '}
                {translate('admin-dashboard.benefit-details.table.modal.run-out-days')}
              </span>{' '}
              <br />
              <DefaultSelect
                name="runOutDays"
                defaultValue={[endPerkRunOutDays]}
                onChange={onChangeRunOutDays}
                className="width_50"
                placeholder={translate('admin-dashboard.benefit-details.table.modal.run-out-days')}
                items={endPerkOptions}
              />
            </div>
          </div>
        </Formik>
      </Modal>
    </>
  )
}

export default EndPerkModal
